export default "__VITE_ASSET__5631a1da__"